import { EColorLabel } from "@/types/dataset";

export const COLORS = {
  TEAL: {
    900: "#033B33",
    800: "#044D43",
    700: "#066357",
    600: "#077F6F",
    500: "#088C7A",
    400: "#39A395",
    300: "#5AB2A6",
    200: "#8DCAC2",
    100: "#B2DBD6",
    50: "#E6F4F2"
  },
  GREEN: {
    900: "#205304",
    800: "#296C05",
    700: "#338606",
    600: "#44B308",
    500: "#4BC509",
    400: "#6FD13A",
    300: "#86D85A",
    200: "#ACE48E",
    100: "#C7EDB3",
    50: "#EDF9E6"
  },
  VIOLET: {
    900: "#610366",
    800: "#800486",
    700: "#A505AD",
    600: "#D306DD",
    500: "#E807F3",
    400: "#ED39F5",
    300: "#F059F7",
    200: "#F48DF9",
    100: "#F8B2FB",
    50: "#FDE6FE"
  },
  BLUE: {
    900: "#152269",
    800: "#1C2D8A",
    700: "#243AB2",
    600: "#2E4AE4",
    500: "#3351FA",
    400: "#5C74FB",
    300: "#768AFC",
    200: "#A1AFFD",
    100: "#C0C9FD",
    50: "#EBEEFF"
  },
  MARINE: {
    900: "#08425B",
    800: "#0A5677",
    700: "#0D6F9A",
    600: "#108FC5",
    500: "#129DD9",
    400: "#41B1E1",
    300: "#60BDE6",
    200: "#92D2EE",
    100: "#B6E1F3",
    50: "#E7F5FB"
  },
  TURQUOISE: {
    900: "#02543F",
    800: "#036D53",
    700: "#048D6B",
    600: "#05B589",
    500: "#05C796",
    400: "#37D2AB",
    300: "#58D9B9",
    200: "#8CE5CF",
    100: "#B2EEDE",
    50: "#E6F9F5"
  },
  ORANGE: {
    900: "#673A04",
    800: "#874C05",
    700: "#B15E00",
    600: "#E07E08",
    500: "#F68B09",
    400: "#F8A23A",
    300: "#F9B15A",
    200: "#FBCA8E",
    100: "#FCDBB3",
    50: "#FEF3E6"
  },
  RED: {
    900: "#5B0808",
    800: "#770A0A",
    700: "#9A0D0D",
    600: "#C51010",
    500: "#D91212",
    400: "#E14141",
    300: "#E66060",
    200: "#EE9292",
    100: "#F3B6B6",
    50: "#FBE7E7"
  },
  PINK: {
    900: "#683743",
    800: "#884957",
    700: "#B05E71",
    600: "#E27891",
    500: "#F8849F",
    400: "#F99DB2",
    300: "#FAADBF",
    200: "#FCC6D3",
    100: "#FDD9E1",
    50: "#FEF3F5"
  },
  PURPLE: {
    900: "#2B1E3E",
    800: "#452F51",
    700: "#5F4164",
    600: "#7A5477",
    500: "#966888",
    400: "#AF8092",
    300: "#C59AA1",
    200: "#D9B5B3",
    100: "#EAD1C9",
    50: "#F8EFED"
  },
  GRAY: {
    900: "#1A1A1A",
    800: "#333333",
    700: "#4D4D4D",
    600: "#666666",
    500: "#808080",
    400: "#999999",
    300: "#B3B3B3",
    200: "#CCCCCC",
    100: "#E6E6E6",
    50: "#F2F2F2"
  },
  CYBER_SUNSET: {
    900: "#8CE5CF",
    800: "#05B589",
    700: "#F8B2FB",
    600: "#D306DD",
    500: "#A1AFFD",
    400: "#2E4AE4",
    300: "#FBCA8E",
    200: "#E07E08",
    100: "#EE9292",
    50: "#C51010"
  },
  SPRING_MEADOW: {
    900: "#ACE48E",
    800: "#358C06",
    700: "#92D2EE",
    600: "#0D6F9A",
    500: "#F9F48D",
    400: "#ACA405",
    300: "#FCC6D3",
    200: "#B05E71",
    100: "#A1AFFD",
    50: "#243AB2"
  },
  DESERT_OASIS: {
    900: "#874C05",
    800: "#E07E08",
    700: "#F8A23A",
    600: "#F9B15A",
    500: "#FCDBB3",
    400: "#B2EEDE",
    300: "#58D9B9",
    200: "#37D2AB",
    100: "#05B589",
    50: "#036D53"
  },
  WATERMELON: {
    900: "#770A0A",
    800: "#C51010",
    700: "#E14141",
    600: "#E66060",
    500: "#F3B6B6",
    400: "#C7EDB3",
    300: "#86D85A",
    200: "#6FD13A",
    100: "#44B308",
    50: "#296C05"
  },
  HEAT_WAVE: {
    900: "#C51010",
    800: "#E14141",
    700: "#F68B09",
    600: "#F9B15A",
    500: "#FBCA8E",
    400: "#92D2EE",
    300: "#60BDE6",
    200: "#129DD9",
    100: "#5C74FB",
    50: "#2E4AE4"
  },
  NEON_CANDY: {
    900: "#D306DD",
    800: "#ED39F5",
    700: "#F8849F",
    600: "#FAADBF",
    500: "#FCC6D3",
    400: "#ACE48E",
    300: "#86D85A",
    200: "#4BC509",
    100: "#37D2AB",
    50: "#05B589"
  },
  RETRO_ARCADE: {
    900: "#2E4AE4",
    800: "#5C74FB",
    700: "#E27891",
    600: "#F99DB2",
    500: "#C51010",
    400: "#E14141",
    300: "#E07E08",
    200: "#F8A23A",
    100: "#05B589",
    50: "#37D2AB"
  },
  TROPICAL_PUNCH: {
    900: "#C51010",
    800: "#E07E08",
    700: "#4BC509",
    600: "#358C06",
    500: "#05B589",
    400: "#2E4AE4",
    300: "#1C2D8A",
    200: "#E807F3",
    100: "#800486",
    50: "#E14141"
  },
  MOSAIC: {
    900: "#1F77B4",
    800: "#FF7F0E",
    700: "#2CA02C",
    600: "#D62728",
    500: "#9467BD",
    400: "#8C564B",
    300: "#E377C2",
    200: "#7F7F7F",
    100: "#BCBD22",
    50: "#17BECF"
  }
};

type ColorShade = 900 | 800 | 700 | 600 | 500 | 400 | 300 | 200 | 100 | 50;

export const COLOR_KEYS: ColorShade[] = [
  900, 800, 700, 600, 500, 400, 300, 200, 100, 50
];

export const CHART_COLORS = [
  "#088C7A",
  "#6FD13A",
  "#5C74FB",
  "#F8A23A",
  "#ED39F5",
  "#41B1E1",
  "#37D2AB",
  "#F5EC39",
  "#E14141",
  "#F99DB2"
];

export const COLOR_LABEL = {
  [EColorLabel.BLACK_WHITE]: {
    COLOR: "#000000",
    HALO_COLOR: "#FFFFFF"
  },
  [EColorLabel.WHITE_BLACK]: {
    COLOR: "#FFFFFF",
    HALO_COLOR: "#000000"
  }
};

type ColorLabelShade = "COLOR" | "HALO_COLOR";

export const COLOR_LABEL_KEYS: ColorLabelShade[] = ["COLOR", "HALO_COLOR"];

export const QualitativeColors = ["CYBER_SUNSET", "SPRING_MEADOW"];

export const DivergingColors = [
  "DESERT_OASIS",
  "WATERMELON",
  "HEAT_WAVE",
  "NEON_CANDY"
];

export const CyclicalColors = ["RETRO_ARCADE", "TROPICAL_PUNCH", "MOSAIC"];

export const GradientColors = [
  "TEAL",
  "GREEN",
  "VIOLET",
  "BLUE",
  "MARINE",
  "TURQUOISE",
  "ORANGE",
  "RED",
  "PINK",
  "PURPLE",
  "GRAY"
];

export const ALL_COLORS = [
  ...GradientColors,
  ...QualitativeColors,
  ...DivergingColors,
  ...CyclicalColors
];

export const COLOR_SCALE_MAP: Record<string, ColorShade[]> = {
  2: [600, 200],
  3: [600, 200, 100],
  4: [700, 600, 200, 100],
  5: [700, 600, 200, 100, 50],
  6: [700, 600, 500, 200, 100, 50],
  7: [700, 600, 500, 400, 200, 100, 50],
  8: [700, 600, 500, 400, 300, 200, 100, 50],
  9: [800, 700, 600, 500, 400, 300, 200, 100, 50],
  10: [900, 800, 700, 600, 500, 400, 300, 200, 100, 50]
};

export const QUALITATIVE_COLOR_SCALE_MAP: Record<string, ColorShade[]> = {
  2: [900, 800],
  3: [900, 800, 700],
  4: [900, 800, 700, 600],
  5: [900, 800, 700, 600, 500],
  6: [900, 800, 700, 600, 500, 400],
  7: [900, 800, 700, 600, 500, 400, 300],
  8: [900, 800, 700, 600, 500, 400, 300, 200],
  9: [900, 800, 700, 600, 500, 400, 300, 200, 100],
  10: [900, 800, 700, 600, 500, 400, 300, 200, 100, 50]
};

export const DIVERGING_COLORS_SCALE_MAP: Record<string, ColorShade[]> = {
  2: [900, 50],
  3: [900, 800, 50],
  4: [900, 800, 100, 50],
  5: [900, 800, 700, 100, 50],
  6: [900, 800, 700, 200, 100, 50],
  7: [900, 800, 700, 500, 200, 100, 50],
  8: [900, 800, 700, 500, 400, 200, 100, 50],
  9: [900, 800, 700, 600, 500, 400, 200, 100, 50],
  10: [900, 800, 700, 600, 500, 400, 300, 200, 100, 50]
};

export const CYCLICAL_COLOR_SCALE_MAP: Record<string, ColorShade[]> = {
  2: [500, 400],
  3: [600, 500, 400],
  4: [600, 500, 400, 300],
  5: [700, 600, 500, 400, 300],
  6: [700, 600, 500, 400, 300, 200],
  7: [800, 700, 600, 500, 400, 300, 200],
  8: [800, 700, 600, 500, 400, 300, 200, 100],
  9: [900, 800, 700, 600, 500, 400, 300, 200, 100],
  10: [900, 800, 700, 600, 500, 400, 300, 200, 100, 50]
};
